
export const data = [
    {
      id: 1,
      level:'A2',
      question: "Ich gehe heute Abend ....... Fitnessstudio und dann ...... Mark  nach Hause.",
      explanation: 'INS - in das Fitnessstudio (wohin? ) ,  Akkusativ  ZU  - gehen zu + Person : zu Mark',
      correctAnswer:"INS ..... ZU",
        answers: [
          { id:1,
            text: "IN ..... ZU",
            correct: false,
          },
          { id:2,
            text: "INS ..... MIT",
            correct: false,
          },
          { id:3,
            text: "NACH ..... ZUM",
            correct: false,
          },
          { id:4,
            text: "INS ..... ZU",
            correct: true,
          },
        ],
    },
    {
      id: 2,
      level:'A2',
      question: "Ich wünsche Ihnen ........  Urlaub",
      explanation: 'wünschen (was ?) + Akkusativ',
      correctAnswer:"EINEN ..... SCHÖNEN",
        answers: [
          { id:1,
            text: "EINEN SCHÖNEN",
            correct: true,
          },
          { id:2,
            text: "EINE SCHÖNE",
            correct: false,
          },
          { id:3,
            text: "EIN SCHÖNES",
            correct: false,
          },
          { id:4,
            text: "EIN SCHÖNENE",
            correct: false,
          },
        ],
    },
    {
      id: 3,
      level:'A2',
      question: "Heute musst du Geschirr ........",
      explanation: `Kleidung WASCHEN,  den Boden oder Staub WISCHEN ,  das Fenster oder das Badeszimmer PUTZEN}`  ,
      correctAnswer:"SPÜLEN",
        answers: [
          { id:1,
            text: "WASCHEN",
            correct: false,
          },
          { id:2,
            text: "SPÜLEN",
            correct: true,
          },
          { id:3,
            text: "WISCHEN",
            correct: false,
          },
          { id:4,
            text: "PUTZEN",
            correct: false,
          },
        ],
    },

{
  id: 4,
  level:'A2',
  question: "Sehr ........ Damen und Herren.",
  explanation: 'ein Mann - Sehr geehrter Herr Müller,     eine Frau - Sehr geehrte Frau Müller,       Plural - Sehr geehrte ',
  correctAnswer:"GEEHRTENE",
      answers: [
      { id:1,
        text: "GEEHRTE",
        correct: false,
      },
      { id:2,
        text: "GEEHRTER",
        correct: false,
      },
      { id:3,
        text: "GEEHRTEN",
        correct: false,
      },
      { id:4,
        text: "GEEHRTENE",
        correct: true,
      },
    ],
},
{
  id: 5,
  level:'B1',
  question: "Ich habe ihn gleich mit der Rechnung .........",
  explanation: 'PERFEKTUM -   GEBRACHT ',
  correctAnswer:"ZURÜCKGEBRACHT",
      answers: [
      { id:1,
        text: "ZURÜCKGEBRACHT",
        correct: true,
      },
      { id:2,
        text: "ZURÜCKGEBRINGEN",
        correct: false,
      },
      { id:3,
        text: "ZURÜCKBRINGEN",
        correct: false,
      },
      { id:4,
        text: "ZURÜCKGEBRINGT",
        correct: false,
      },
    ],
},
    {
      id: 6,
      level:'B1',
      question: "Wir wollen ein Auto kaufen, ......... wir nicht mehr mit dem Bus fahren müssen.",
      explanation: ' "DAMIT" drückt den Zweck aus und antwortet auf die Frage "Wozu?"  ',
      correctAnswer:"DAMIT",
        answers: [
          { id:1,
            text: "UM",
            correct: false,
          },
          { id:2,
            text: "WEIL",
            correct: false,
          },
          { id:3,
            text: "DENN",
            correct: false,
          },
          { id:4,
            text: "DAMIT",
            correct: true,
          },
        ],
    },
    {
      id: 7,
      level:'B1',
      question: "Nachdem er mir das erzählt ......... war ich erstaunt",
      explanation: 'Nachdem benutzen wir normalerweise mit Plusquamperfekt wenn im Hauptsatz Präteritum oder Perfekt ist. Hier haben wir Präteritum ',
      correctAnswer:"HATTE",
        answers: [
          { id:1,
            text: "HAT",
            correct: false,
          },
          { id:2,
            text: "WAR",
            correct: false,
          },
          { id:3,
            text: "HATTE",
            correct: true,
          },
          { id:4,
            text: "HÄTTE",
            correct: false,
          },
        ],
    },
    {
      id: 8,
      level:'B1',
      question: "Tom ist am Wochenende 18 geworden. Somit ist er jetzt ........",
      explanation: 'wenn du 18 bist dann bist du volljährig.  Das gegenteil davon ist minderjährig ',
      correctAnswer:"VOLLJÄHRIG",
        answers: [
          { id:1,
            text: "GANZÄHRIG",
            correct: false,
          },
          { id:2,
            text: "MINDEJÄHRIG",
            correct: false,
          },
          { id:3,
            text: "VIELJÄHRIG",
            correct: false,
          },
          { id:4,
            text: "VOLLJÄHRIG",
            correct: true,
          },
        ],
    },
//B2
{
  id: 9,
  level:'B2',
  question: "....... Sie unterschiedliche Meinungen akzeptieren, diskutieren die Leute hier gerne",
  explanation: 'DADURCH ist ein Konnektor der zeigt die Art und Weise wie Man etwas macht ',
  correctAnswer:"DADURCH DASS",
    answers: [
      { id:1,
        text: "DA",
        correct: false,
      },
      { id:2,
        text: "DADURCH DASS",
        correct: true,
      },
      { id:3,
        text: "OBWOHL",
        correct: false,
      },
      { id:4,
        text: "TROTZ DASS",
        correct: false,
      },
    ],
},
{
  id: 10,
  level:'B2',
  question: "Immer sieht er so müde aus, ........ hätte er die ganze Nacht durchgearbeitet",
  explanation: 'ALS - IRREALER VERGLEICH ',
  correctAnswer:"ALS",
    answers: [
      { id:1,
        text: "ALS OB",
        correct: false,
      },
      { id:2,
        text: "ALS",
        correct: true,
      },
      { id:3,
        text: "WENN",
        correct: false,
      },
      { id:4,
        text: "WIE",
        correct: false,
      },
    ],
},

{
  id: 11,
  level:'B2',
  question: "Hier darf man nicht rauchen. Das rauchen ist hier strengstens ........",
  explanation: `VERSAGEN - scheitern oder Misserfolg haben ,
                ABSAGEN  - eien Termin absagen, 
                SAGEN - sprechen `,
  correctAnswer:"UNTERSAGT",
    answers: [
      { id:1,
        text: "VERSAGT",
        correct: false,
      },
      { id:2,
        text: "UNTERSAGT",
        correct: true,
      },
      { id:3,
        text: "ABGESAGT",
        correct: false,
      },
      { id:4,
        text: "GESAGT",
        correct: false,
      },
    ],
},

{
  id: 12,
  level:'B2',
  question: "Ich nehme dich ........ Wort",
  explanation: 'Jemanden beim / bei seinem Wort nehmen ',
  correctAnswer:"BEIM",
    answers: [
      { id:1,
        text: "BEIM",
        correct: true,
      },
      { id:2,
        text: "ZUM",
        correct: false,
      },
      { id:3,
        text: "AM",
        correct: false,
      },
      { id:4,
        text: "VOM",
        correct: false,
      },
    ],
},




  ]



